import { lazy } from "react";

export const ReadingsAsync = lazy(() => import("./Readings"));
